import { Component, OnInit, ElementRef, Inject } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ISeguimentTecnic } from '../../manage-seguiment-tecnic-projectes/manage-seguiment-tecnic.interfaces';
import { CollaboratorsService } from '../../services/collaborators/collaborators.service';
import { SeguimentTecnicService } from './services/seguiment-tecnic.service';
import { ProjectsService } from '../../services/projects-proposals-service/projects-proposals.service';

import * as moment from 'moment';

@Component({
  selector: 'dialog-seguiment-tecnic',
  templateUrl: 'dialog.component.seguiment-tecnic.html',
  styleUrls: ['dialog.component.seguiment-tecnic.css'],
  providers: [CollaboratorsService, ProjectsService, SeguimentTecnicService]
})
export class DialogSeguimentTecnic {
  //public possibleTipus: Array<string> = [];
  public possibleTipus: { codi: string; text: string; }[];

  //public possibleSubTipus: Array<string> = [];
  public possibleSubTipus: { codi: string; text: string; }[];
  
  public possibleAssistents: Array<string> = [];
  
  public llistaParticipants: Array<string> = [];
  
  public seguiment: ISeguimentTecnic = {'id': 0, 'projecte_codi': '', 'titol': '', 'tipus': '',
  'ambit_proposta': '', 'sub_tipus': '', 'participants': '', 'assumpte': '', 'data': '', 'hora': '', 'data_realitzacio': '', 
  'acords': '', 'lliuraments': '', 'data_avis': '', 'avis_actiu': true,  'lloc': '', 'file': null, 'filename': ''
  };

  private file;
  public editSeguimentTecnicData = Object.assign(
    this.seguiment,
    {},
    {}
  );

  constructor(public translate: TranslateService, public languageService: LanguageService, public dialogRef: MatDialogRef<DialogSeguimentTecnic>, public seguimentTecnicService: SeguimentTecnicService, public collaboratorsService: CollaboratorsService, public dataService: ProjectsService, @Inject(MAT_DIALOG_DATA) public data: any){
    this.editSeguimentTecnicData =  data;
    this.seguimentTecnicService.getTipus().subscribe(tipus => { 
      this.possibleTipus = tipus.map(nomCatala => ({
        codi: nomCatala["nom"], // ← s'envia/compara SEMPRE en català
        text: this.languageService.label('seguimentTipusRaw', nomCatala["nom"]) // ← només es mostra traduït
      }));

      this.seguimentTecnicService.getSubTipus(-1).subscribe(subtipus => { 
        this.possibleSubTipus = subtipus.map(nomCatala => ({
          codi: nomCatala["nom"], // ← s'envia/compara SEMPRE en català
          text: this.languageService.label('seguimentsubTipusRaw', nomCatala["nom"]) // ← només es mostra traduït
        }));
      });
    });

    this.llistaParticipants = (this.editSeguimentTecnicData.participants?this.editSeguimentTecnicData.participants.split(';'):[]);
    this.collaboratorsService.get().subscribe( list => { this.possibleAssistents = list.map(item => item.name); }, err => console.log(err) );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {
    if(this.editSeguimentTecnicData.avis_actiu)if(this.editSeguimentTecnicData.data_avis == ''){alert('Recordeu entrar una data per a l\'avís');return;}
    if(this.editSeguimentTecnicData.tipus == ''){alert('Recordeu entrar un tipus');return;}
    if(this.editSeguimentTecnicData.sub_tipus == ''){alert('Recordeu entrar un subtipus');return;}
    if(this.editSeguimentTecnicData.data == ''){alert('Recordeu entrar una data');return;}
    this.editSeguimentTecnicData.participants = this.llistaParticipants.join(';');
    if(this.editSeguimentTecnicData.participants == ''){alert('Recordeu entrar com a mínim un participant');return;}
    this.dialogRef.close(this.editSeguimentTecnicData);
  }

  close(): void {
    this.dialogRef.close(null);
  }
  
  public chgDataAvis(){
    if(this.data.avis_actiu)this.data.data_avis = moment(this.data.data).locale('ca').subtract(2, "days").format('YYYY-MM-DD');
  }

  public chkDataAvis(){
    if(!this.data.avis_actiu)this.data.data_avis = moment(this.data.data).locale('ca').subtract(2, "days").format('YYYY-MM-DD');
    else this.data.data_avis = null;
  }

  public desarFitxer(event,fitxer, path){
    event.preventDefault(); //!important evitar que la pàgina navegui al registre
    this.dataService.downloadFile(path, fitxer);
  }

  public onFileChange(event){
    let reader = new FileReader();
    if(event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        if(file.size > 100000000){
          alert("Mida límit del fitxer 100Mb!");
          this.editSeguimentTecnicData.filename = ''
          return;
        };
        this.editSeguimentTecnicData.filename = file.name;
        this.editSeguimentTecnicData.file = {
          filename: file.name,
          filetype: file.type,
          value: reader.result
        };
      };
    }else {this.editSeguimentTecnicData.file = null;this.editSeguimentTecnicData.filename = '';}
  }
  //ngOnInit(){}
}